import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden", "results", "template"]

  connect() {
    if (this.hiddenTarget.value) {
      this.inputTarget.value = this.hiddenTarget.dataset.label || ""
    }
    this.boundClose = (e) => {
      if (!this.element.contains(e.target)) {
        this.resultsTarget.classList.add("hidden")
      }
    }
    document.addEventListener("click", this.boundClose)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClose)
  }

  search() {
    const q = this.inputTarget.value.trim()
    this.resultsTarget.innerHTML = ""
    this.resultsTarget.classList.add("hidden")

    if (q.length < 2) return

    fetch(`/matches/autocomplete?q=${encodeURIComponent(q)}`)
      .then(r => r.json())
      .then(matches => {
        if (matches.length === 0) return
        matches.forEach(m => {
          const btn = this.templateTarget.content.cloneNode(true).querySelector("button")
          btn.textContent = m.label
          btn.addEventListener("click", () => this.select(m))
          this.resultsTarget.appendChild(btn)
        })
        this.resultsTarget.classList.remove("hidden")
      })
  }

  select(match) {
    this.inputTarget.value = match.label
    this.hiddenTarget.value = match.id
    this.resultsTarget.innerHTML = ""
    this.resultsTarget.classList.add("hidden")
  }
}
